import { createContext, useEffect, useState } from "react";
import { AdminContext } from "./Admin.Context";


export const RoutingContext = createContext({

    isRoutingState: {
        isWelcomeBarShowing: true,
        isNavLinkClicked: false,
        isMobileNavOpen: false,
        isMobileCategoriesMenuOpen: false,
        isMobileResourcesMenuOpen: false,
        isMobileAccountMenuOpen: false,
        isMobileExclusiveMenuOpen: false,
        isMobileBuilderDropdownOpen: false,

        isCategoriesMenuOpen: false,
        isResourcesMenuOpen: false,
        isAccountMenuOpen: false,
        isExclusiveMenuOpen: false,
        isBuilderDropdownOpen: false,


        isLoading: false,
        isFlashMessage: false,

        isShowScrollToTopButton: false,

    },
    setIsRoutingState: () => { },

    isFlashMessageState: {
        message: '',
        iconType: '',
        styleName: '',
        show: false,
    },
    setIsFlashMessageState: () => { },


    // NEW
    productNavigationState: {
        subcategoryProductLists: {},
    },
    setProductNavigationState: () => { },

});

export const RoutingProvider = ({ children }) => {

    const initialRoutingState = {
        isWelcomeBarShowing: true,
        isNavLinkClicked: false,
        isMobileNavOpen: false,
        isMobileCategoriesMenuOpen: false,
        isMobileResourcesMenuOpen: false,
        isMobileAccountMenuOpen: false,
        isMobileExclusiveMenuOpen: false,
        isMobileBuilderDropdownOpen: false,

        isCategoriesMenuOpen: false,
        isResourcesMenuOpen: false,
        isAccountMenuOpen: false,
        isBuilderDropdownOpen: false,
        isExclusiveMenuOpen: false,

        isLoading: false,
        isFlashMessage: false,

        isShowScrollToTopButton: false,


    }
    const [isRoutingState, setIsRoutingState] = useState(initialRoutingState);

    // **New State for product navigation**
    const [productNavigationState, setProductNavigationState] = useState({
        subcategoryProductLists: {}, // Holds arrays of products indexed by subcategory slug
    });
    const initialFlashMessageState = {
        message: '',
        iconType: '',
        styleName: '',
        show: false,
    }
    const [isFlashMessageState, setIsFlashMessageState] = useState(initialFlashMessageState)

    // Effect to handle mobile nav close actions
    useEffect(() => {
        if (!isRoutingState.isMobileNavOpen) {
            setIsRoutingState(prevState => ({
                ...prevState,
                isMobileCategoriesMenuOpen: false,
                isMobileResourcesMenuOpen: false,
                isMobileAccountMenuOpen: false,
                isMobileBuilderDropdownOpen: false,
                isMobileExclusiveMenuOpen: false,
            }))


        } else if (isRoutingState.isMobileNavOpen) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.body.style.overflow = 'unset';
        }
    }, [isRoutingState.isMobileNavOpen])


    useEffect(() => {
        if (isRoutingState.isBuilderDropdownOpen ||
            isRoutingState.isMobileBuilderDropdownOpen ||
            isRoutingState.isMobileNavOpen
        ) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.body.style.overflow = 'unset';
        }

    }, [
        isRoutingState.isBuilderDropdownOpen,
        isRoutingState.isMobileBuilderDropdownOpen,
        isRoutingState.isMobileNavOpen
    ])
    // Effect to handle nav link click events
    useEffect(() => {
        // if (isRoutingState.isBuilderDropdownOpen && isRoutingState.isNavLinkClicked) {
        if (isRoutingState.isNavLinkClicked) {
            setIsRoutingState(prevState => ({
                ...prevState,
                isBuilderDropdownOpen: false,
                isMobileNavOpen: false,
                isMobileCategoriesMenuOpen: false,
                isMobileResourcesMenuOpen: false,
                isMobileAccountMenuOpen: false,
                isMobileExclusiveMenuOpen: false,
                isMobileBuilderDropdownOpen: false,
                isCategoriesMenuOpen: false,
                isResourcesMenuOpen: false,
                isAccountMenuOpen: false,
                isBuilderDropdownOpen: false,
                isExclusiveMenuOpen: false,
            }));

            // Reset isNavLinkClicked to allow subsequent clicks
            const resetNavClick = setTimeout(() => {
                setIsRoutingState(prevState => ({
                    ...prevState,
                    isNavLinkClicked: false,
                }));
            }, 100);

            return () => clearTimeout(resetNavClick);
        }
    }, [isRoutingState.isNavLinkClicked])


    return (
        <RoutingContext.Provider
            value={{
                isRoutingState,
                setIsRoutingState,
                isFlashMessageState,
                setIsFlashMessageState,

                productNavigationState,       // <-- added here
                setProductNavigationState,    // <-- added here
            }}
        >
            {children}
        </RoutingContext.Provider>
    );
}
